// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__JNZ0L","wrapper_portable":"styles_wrapper_portable__3eIs3","contentWrapper":"styles_contentWrapper__JtTQ9"};